export default __webpack_public_path__ + "static/media/pro_pic_city_museum.1a48ad70.jpg";